import React from "react";

export default function Eraser() {
  return <div className="eraser">Expo</div>;
}
